module.exports = __webpack_public_path__ + "static/media/23bdb692-3c24-4dda-a992-7f387450a5e4.f78cb57b.png";